<template>
    <span :class="statusSpecificConfig.class">
        <i :class="statusSpecificConfig.icon"></i> {{ statusSpecificConfig.text }}
    </span>
</template>

<script>
import TeamStatues from "../../consts/teamStatues";

export default {
    name: 'TeamStatusLabel',

    props: {
        teamStatus: {
            required: true,
            type: String,
        },
    },

    data() {
        return {
            config: {
                [TeamStatues.TEAM_STATUS_PENDING]: {
                    class: 'text-danger',
                    icon: 'fa fa-clock',
                    text: 'Pending',
                },
                [TeamStatues.TEAM_STATUS_WAITING_LIST_PENDING]: {
                    class: 'text-danger',
                    icon: 'fa fa-clock',
                    text: 'Pending',
                },
                [TeamStatues.TEAM_STATUS_WAITING_LIST_JOINED]: {
                    class: 'text-warning',
                    icon: 'fa fa-clock',
                    text: 'Joined - Waiting List',
                },
                [TeamStatues.TEAM_STATUS_WAITING_LIST_INVITED]: {
                    class: 'text-success',
                    icon: 'fa fa-clock',
                    text: 'Invited - Waiting List',
                },
                [TeamStatues.TEAM_STATUS_WAITING_LIST_EXPIRED]: {
                    class: 'text-danger',
                    icon: 'fa fa-times-circle',
                    text: 'Expired - Waiting List',
                },
                [TeamStatues.TEAM_STATUS_COMPLETED]: {
                    class: 'text-success',
                    icon: 'fa fa-check-circle',
                    text: 'Completed',
                },
                [TeamStatues.TEAM_STATUS_REMOVED]: {
                    class: 'text-danger',
                    icon: 'fa fa-remove',
                    text: 'Removed',
                },
            },
        }
    },

    computed: {
        statusSpecificConfig() {
            return this.config[this.teamStatus];
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Teams/Utilities/Lables/TeamStatusLabel.vue